export class CostReviewPrefab {
  prefabControllerUsed!: string;
  isReasonForExceptionVisible!: boolean;
  reasonForException!: string;
  isPrefabControllerVisible!: boolean;
}
